<template>
	<ParamWrapper v-bind="wrapperProps">
		<TableFilterConditionGenerator
			@onChange="onRulesChange"
			:param="param"
			:node="node"
			:rules="localValue || undefined"
			:readonly="readonly"
		/>
	</ParamWrapper>
</template>

<script>
import ParamTypeMixin from './mixins/ParamTypeMixin';
import TableFilterConditionGenerator from '../../TableActionEditor/TableFilterConditionGenerator/TableFilterConditionGenerator';
export default {
	name: 'RulesParamType',
	mixins: [ParamTypeMixin],
	components: { TableFilterConditionGenerator },
	methods: {
		onRulesChange(newFilter) {
			if (newFilter !== '') {
				this.localValue = newFilter;
			}
		},
	},
	computed: {},
	data() {
		return {};
	},
};
</script>
<style lang="scss" scoped></style>
